import styled from "styled-components";
import { Field, Input } from "discover.medical.react-component-library";

export const DIFilterContainer = styled.div`
  width: 100%;
`;

export const DILabel = styled(Field)`
  width: auto;
  &&& > label {
    min-width: 0;
  }
`;

export const DIFilter = styled(Input.Select)`
  width: 85%;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: 60%;
  }
`;
